import { render, staticRenderFns } from "./LeaveMassageIndex.vue?vue&type=template&id=070fde5a&scoped=true"
import script from "./LeaveMassageIndex.vue?vue&type=script&lang=js"
export * from "./LeaveMassageIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070fde5a",
  null
  
)

export default component.exports